<template>
  <footer class="footer">
    <div class="footer-inner">
      <p class="project-name">
        okibi
      </p>
      <p class="tiget grey-txt" @click="routerPush(topUrl)">
        電子チケット・ライブ配信ならTIGET
      </p>
      <p class="sign-up grey-txt" @click="routerPush(signUpUrl)">
        新規会員登録
      </p>
      <p class="copy grey-txt">
        {{ footerLabel }}
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    topUrl: {
      type: String
    },
    signUpUrl: {
      type: String
    }
  },
  methods: {
    routerPush: function (path) {
      window.location.href = path
    }
  },
  computed: {
    footerLabel: function () {
      return "Copyright (C) " + (new Date()).getFullYear() + " grabss Inc. All rights reserved."
    }
  }
}
</script>

<style lang="scss" scoped>
$breakpoint: 767px;

.footer {
  background-color: #fff;
  padding: 100px 0;
  margin-top: 80px;

  @media screen and (max-width: $breakpoint) {
    padding: 50px 0;
    margin-top: 50px;
  }
  &-inner {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      display: inline-block;
    }
    
    .project-name {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 50px;

      @media screen and (max-width: $breakpoint) {
        margin-bottom: 30px;
      }
    }

    .grey-txt{
      color: #999;
    }

    .tiget,
    .sign-up {
      cursor: pointer;
      font-size: 13px;
      transition: .2s;

      &:hover {
        opacity: 0.7;
      }
    }

    .tiget {
      margin-bottom: 10px;
    }

    .sign-up {
      margin-bottom: 50px;

      @media screen and (max-width: $breakpoint) {
        margin-bottom: 30px;
      }
    }

    .copy {
      font-size: 11px;
    }
  }
}
</style>